import { render } from "./blog-article-creation.vue?vue&type=template&id=082e2e2e"
import script from "./blog-article-creation.vue?vue&type=script&lang=js"
export * from "./blog-article-creation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__